import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { ResizeObserver } from '@juggle/resize-observer';
import { Subject } from 'rxjs';
import { BasicConfigService } from '@core/service/basicConfig.service';
import { takeUntil, filter } from 'rxjs/operators';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Router } from '@angular/router';
import { setMenuCollapsed } from '../layout.store';

@Component({
  selector: 'layout-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.less']
})
export class LayoutSidebarComponent implements OnInit, OnDestroy {
  readonly SIDEBAR_WIDTH = 200;

  deployTitle: string;
  contentTitle: string;
  hideContentTitle: boolean;
  noPermission: boolean;
  needBigGroup: boolean;
  emptyMenu: boolean;
  videoTutorial: boolean;
  tip = '';
  isTipShow = false;
  WorkersData: { [key: string]: any };
  moveTime: string;
  moveCus: string;
  moveTitle: string;
  showMoveBefore: boolean = false;

  private ro: ResizeObserver;
  private destroySub$: Subject<void> = new Subject<void>();

  constructor(
    private readonly store: Store<{
      layout: {
        title: string;
        hideContentTitle: boolean;
        deadlineDay: number;
        roles: string[];
        noPermission: boolean;
        needBigGroup: boolean;
        emptyMenu: boolean;
        videoTutorial: boolean;
      };
    }>,
    private readonly ModalService: NzModalService,
    private changeRef: ChangeDetectorRef,
    private router: Router,
    private readonly configService: BasicConfigService
  ) {
    this.deployTitle = this.configService.get<{ [key: string]: string }>('InfoDeploy').systemName;
    this.WorkersData = this.configService.get<{ [key: string]: any }>('CustonMadeConfig');
    this.showMoveBefore = this.configService.get<boolean>('showMoveBefore');
    this.moveTime = this.configService.get<string>('moveTime');
    this.moveCus = this.configService.get<string>('moveCus');
    this.moveTitle = this.configService.get<string>('moveTitle');
  }

  ngOnInit(): void {
    this.sidebarChanged(false);

    this.store
      .select(state => state.layout)
      .pipe(
        filter(layout => !!layout),
        takeUntil(this.destroySub$)
      )
      .subscribe(layout => {
        this.videoTutorial = layout.videoTutorial;
        this.contentTitle = layout.title ?? '';
        this.hideContentTitle = layout.hideContentTitle;
        if (this.router.url === '/') {
          this.noPermission = false;
          this.needBigGroup = false;
          this.emptyMenu = false;
          setTimeout(() => {
            this.noPermission = layout.noPermission;
            this.needBigGroup = layout.needBigGroup;
            this.emptyMenu = layout.emptyMenu;
            this.hideContentTitle = this.noPermission || this.needBigGroup ? false : layout.hideContentTitle;
          });
        } else {
          Promise.resolve(null).then(() => {
            this.noPermission = layout.noPermission === false ? layout.noPermission : true;
            this.needBigGroup = layout.needBigGroup === false ? layout.needBigGroup : true;
            this.emptyMenu = layout.emptyMenu === false ? layout.emptyMenu : true;
            this.hideContentTitle = this.noPermission || this.needBigGroup ? false : layout.hideContentTitle;
          });
        }
      });
    this.ro = new ResizeObserver((entries, observer) => {
      for (const entry of entries) {
        const { left, top, width, height } = entry.contentRect;
        const contentElement = document.querySelector<HTMLElement>('.right-content');
        contentElement.style.height = `calc(100% - ${height + 20}px)`;
      }
    });

    const titleElement = document.querySelector<HTMLElement>('.right-content-title');
    this.ro.observe(titleElement);
  }

  ngOnDestroy(): void {
    this.ro?.disconnect();
    this.destroySub$.next();
    this.destroySub$.complete();
  }

  sidebarChanged(isCollapsed: boolean) {
    this.store.dispatch(setMenuCollapsed({ collapsed: isCollapsed }));
  }
}
